import { createActionGroup, emptyProps, props  } from "@ngrx/store";
import { Settings } from "@models/settings.model";

export const SettingsActions = createActionGroup({
    source: 'Settings',
    events: {
        // Action dispatched by the UI to update settings
        'Update Settings': props<{ settings: Settings }>(),
        // Action dispatched by the Effects to load settings from IndexedDB
        'Load Settings': emptyProps(),
        // Action dispatched by the Effects once settings are loaded from IndexedDB
        'Load Settings Success': props<{ settings: Settings }>(),
        // Action dispatched by the Effects if loading settings from IndexedDB fails
        'Load Settings Failure': props<{ error: any }>(),
    }
});